import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {

  const navigate = useNavigate();
  const location = useLocation();
  
  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.querySelector(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else {
      const element = document.querySelector(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <header id="header" className="header d-flex align-items-center sticky-top">
      <div className="container-fluid container-xl position-relative d-flex align-items-center">
        <a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="logo d-flex align-items-center me-auto">
          {/* <h1 className="sitename">eNno</h1> */}
          <img src='assets/img/logo.jpeg' style={{height:'150px', width:'250px',marginTop:'20px'}}/>
        </a>

        <nav id="navmenu" className="navmenu">
          <ul>
            <li><a href="#hero" onClick={(e) => handleNavClick(e, '#hero')} className="active">Home</a></li>
            <li><a href="#about" onClick={(e) => handleNavClick(e, '#about')}>About</a></li>
            <li><a href="#services" onClick={(e) => handleNavClick(e, '#services')}>Services</a></li>
            <li><a href="#portfolio" onClick={(e) => handleNavClick(e, '#portfolio')}>Portfolio</a></li>
            <li><a href="#team" onClick={(e) => handleNavClick(e, '#team')}>Team</a></li>
            {/* <li className="dropdown">
              <a href="#dropdown">
                <span>Dropdown</span> 
                <i className="bi bi-chevron-down toggle-dropdown"></i>
              </a>
              <ul>
                <li><a href="#dropdown1">Dropdown 1</a></li>
                <li className="dropdown">
                  <a href="#deep-dropdown">
                    <span>Deep Dropdown</span> 
                    <i className="bi bi-chevron-down toggle-dropdown"></i>
                  </a>
                  <ul>
                    <li><a href="#deep1">Deep Dropdown 1</a></li>
                    <li><a href="#deep2">Deep Dropdown 2</a></li>
                    <li><a href="#deep3">Deep Dropdown 3</a></li>
                    <li><a href="#deep4">Deep Dropdown 4</a></li>
                    <li><a href="#deep5">Deep Dropdown 5</a></li>
                  </ul>
                </li>
                <li><a href="#dropdown2">Dropdown 2</a></li>
                <li><a href="#dropdown3">Dropdown 3</a></li>
                <li><a href="#dropdown4">Dropdown 4</a></li>
              </ul>
            </li> */}
            <li><a href="#contact" onClick={(e) => handleNavClick(e, '#contact')}>Contact</a></li>
          </ul>
          <i className="mobile-nav-toggle d-xl-none bi bi-list"></i>
        </nav>

        <a className="btn-getstarted" href="#about" onClick={(e) => handleNavClick(e, '#about')}>Get Started</a>
      </div>
    </header>
  );
};

export default Header;
